import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'; // Import MatDialogRef
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { AppRoute } from 'app/shared/app.routes';

@Component({
  selector: 'app-subscription-popup',
  templateUrl: './subscription-popup.component.html',
  standalone:true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule, 
    MatToolbarModule, 
    RouterModule
  ],
  // styles: [`
  //   .popup-overlay {
  //     position: fixed;
  //     top: 0;
  //     left: 0;
  //     right: 0;
  //     bottom: 0;
  //     background: rgba(0, 0, 0, 0.5);
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     z-index: 1000;
  //   }

  //   .popup-content {
  //     background-color: white;
  //     padding: 20px;
  //     border-radius: 8px;
  //     max-width: 400px;
  //     text-align: center;
  //     box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  //   }

  //   .popup-title {
  //     margin: 0;
  //     font-size: 20px;
  //     font-weight: bold;
  //   }

  //   .popup-message {
  //     font-size: 16px;
  //     margin: 15px 0;
  //   }

  //   .popup-close-btn {
  //     background-color: #007bff;
  //     color: white;
  //     border: none;
  //     padding: 10px 20px;
  //     border-radius: 5px;
  //     cursor: pointer;
  //     font-size: 16px;
  //   }

  //   .popup-close-btn:hover {
  //     background-color: #0056b3;
  //   }
  // `]
})
export class SubscriptionPopupComponent {
  constructor(
    private _router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, isFreePlan: boolean, isPlanExpired: boolean }, 
    private dialogRef: MatDialogRef<SubscriptionPopupComponent>  
  ) { 
    console.log('Injected Data:', this.data); 
  }

  onPlanPurchase(){
    this._router.navigate([AppRoute.plan]);
    this.dialogRef.close();  
  }

  onClose(): void {
    console.log('Closing the popup');
    this.dialogRef.close();  
    
  }


}

